import axios from "axios";
import { userModule } from "@/store/modules/user";
import router from "@/router";
import ErrorAlert from "@/utility/ErrorAlert";
import SimrsNotif from "@/utils/SimrsNotif";
import ClientSystemStore from "@/store/modules/ClientSystemStore";
import { simpanPesanLogin } from "@/utils/pesanLogin";

const API_URL = process.env.VUE_APP_API_KASIR;

const instance = axios.create({
  baseURL: API_URL,
  timeout: 20000,
  params: {} // do not remove this, its added to add params later in the config
});

// Add a request interceptor
instance.interceptors.request.use(
  function(config) {
    const token = userModule.token;
    // console.log("token", token);
    if (token) {
      config.headers.common["Authorization"] = "Bearer " + token;
      config.headers.common["Access-Control-Allow-Origin"] = "*";
      config.headers.common["X-Timestamp"] = Math.floor(Date.now() / 1000);
    } else {
      // Use application/x-www-form-urlencoded for login
      config.headers.common["Content-Type"] =
        "application/x-www-form-urlencoded";
    }
    return config;
  },
  function(error) {
    // Do something with request error
    // alert("login err")
    // console.log("error log on request interceptor ", error);

    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;

    if (status === 401) {
      const sempatMasuk = userModule.isSignedIn;

      userModule.clearSession();

      const msg =
        error.response?.data?.message ??
        "Autentikasi User gagal atau sesi Anda telah habis";

      if (sempatMasuk) {
        simpanPesanLogin(msg);
      }

      router.push({ name: "Login" });
    } else {
      ErrorAlert.showErrorAlert(error);

      if (status === 500) {
        const notif = new SimrsNotif();

        setTimeout(() => {
          const ip = ClientSystemStore.client?.ip;

          notif.send(
            `IP: ${ip} ==> ` +
              "ERROR " +
              error.response.status +
              " : " +
              error.response.data.message,
            1800
          );
        }, 1000);
      }
    }

    return Promise.reject(error);
  }
);

export default {
  getAPI() {
    const url = `${API_URL}`;
    return url;
  },
  getData(endpoint) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.get(url);
  },
  getDataParam(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    data = "params" in data ? data : { params: data };
    return instance.get(url, data);
  },
  postData(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.post(url, data);
  },
  putData(endpoint, data, config = null) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.put(url, data, config);
  },
  deleteData(endpoint) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.delete(url);
  },
  login(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.get(url, data);
  },
  deleteDataParam(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.delete(url, data);
  },
  apiUrl: API_URL
};
